import DropdownOptionNew from "components/Common/DropdownOptionNew";
import SearchAddress from "components/Common/SearchAddress";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import { registerLocale } from "react-datepicker";
import { formatDateStringToKorea } from "helpers/format";
import {
  COLOR_APPLICATION_STATUS2,
  LIST_APPLICATION_STATUS,
} from "helpers/constans";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import applicationApi from "api/applicationApi";
import DropdownStatusNew from "components/Common/DropdownStatusNew";

registerLocale("en", en);
registerLocale("ko", ko);

const ApplicationStatus = ({ data, handleUpdateSuccess }: any) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpenSearchAddress, setIsOpenSearchAddress] =
    useState<boolean>(false);
  const [isLoadingMap, setLoadingMap] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    if (!data?.id) return;

    try {
      setIsLoading((_prev) => true);
      const formatValues = {
        status: values?.status,
        reason: values?.reason || "",
        note: values?.note || "",
      };
      const response: any = await applicationApi.updateDetail(
        data?.id,
        formatValues
      );

      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        handleUpdateSuccess && handleUpdateSuccess();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    } finally {
      setIsLoading((_prev) => false);
    }
  };

  const validationSchema = Yup.object({
    // reason: Yup.string().required(`${t("This field is required")}`),
  });

  const renderHideOption = useMemo(() => {
    switch (data?.status) {
      case "SUBMITTED":
        return ["WITHDRAWN"];
      case "VIEWED":
      case "INTERVIEW":
        return ["SUBMITTED", "WITHDRAWN"];
      case "HIRED":
        return ["SUBMITTED", "VIEWED", "INTERVIEW", "REJECTED", "WITHDRAWN"];
      case "REJECTED":
        return ["SUBMITTED", "VIEWED", "INTERVIEW", "HIRED", "WITHDRAWN"];
      case "WITHDRAWN":
        return ["SUBMITTED", "VIEWED", "INTERVIEW", "HIRED", "REJECTED"];

      default:
        return [];
    }
  }, [data?.status]);

  const formik = useFormik({
    initialValues: {
      status: "",
      reason: "",
      note: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleCloseModalAddress = () => {
    setIsOpenSearchAddress(false);
  };

  const handleOpenSearchAddress = () => {
    setIsOpenSearchAddress(true);
  };

  const getLatLngByAddress = async (address: string) => {
    try {
      // if (address) {
      //   const data: any = await addressApi.getGEOByAddress({
      //     query: encodeURIComponent(address),
      //   });
      //   let dataAddress = data?.data?.addresses;
      //   const formatAddress = formatAddressByNaver(dataAddress);
      //   if (formatAddress) {
      //     formik?.setFieldValue("address", formatAddress?.address || '');
      //     formik?.setFieldValue("short_address", formatAddress?.short_address || '');
      //   }
      // }
    } catch (error) {
      //
      console.log(error);
    }
  };

  const onSetValueAddress = async (data: any) => {
    if (data) {
      setLoadingMap(true);
      const res = await getLatLngByAddress(data);
      setLoadingMap(false);
    }
    setIsOpenSearchAddress(false);
  };

  useEffect(() => {
    if (data) {
      formik.setValues({
        ...data,
        status: data?.status,
        reason: data?.reason,
        note: data?.note,
      });
    }
  }, [data]);

  useEffect(() => {
    document.title = `${t("Profile Info")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row className="p-4">
        <Col lg={12} className="">
          <form onSubmit={formik.handleSubmit}>
            <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
              <div className="flex-grow-1">
                <Row>
                  <Col md={6} lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">
                        {t("Application Date")}
                      </Label>
                      <div className="cursor-pointer">
                        {data?.createdAt
                          ? formatDateStringToKorea(data?.createdAt)
                          : "-"
                        }
                      </div>
                    </div>
                  </Col>
                  <Col md={6} lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Last Updated")}</Label>
                      <div className="cursor-pointer">
                        {data?.updatedAt
                          ? formatDateStringToKorea(data?.updatedAt)
                          : "-"
                        }
                      </div>
                    </div>
                  </Col>

                  <Col md={3} lg={3}>
                    <div className="mb-3">
                      <Label htmlFor="status" className="form-label">
                        {t("Current Status")}
                      </Label>
                      <DropdownStatusNew
                        name="status"
                        dataList={LIST_APPLICATION_STATUS}
                        placeholder={`${t("Status")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.status}
                        onChangeSelect={(e: any) =>
                          formik.setFieldValue("status", e?.value)
                        }
                        optionHide={renderHideOption}
                        isHasOptionAll={false}
                        colors={COLOR_APPLICATION_STATUS2}
                      />
                      {formik.touched.status && formik.errors.status ? (
                        <div className="text-danger mt-2">
                          {formik.errors.status}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={12} lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="reason" className="form-label">
                        {t("Reason")}
                      </Label>
                      <Input
                        name="reason"
                        type="textarea"
                        rows="5"
                        className="form-control"
                        id="reason"
                        placeholder={t("Reason")}
                        value={formik?.values?.reason}
                        onChange={(event: any) =>
                          formik.setFieldValue("reason", event?.target?.value)
                        }
                      />
                      {formik.touched.reason && formik.errors.reason ? (
                        <div className="text-danger mt-2">
                          {formik.errors.reason}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col md={12} lg={12}>
                    <div className="mb-3">
                      <Label htmlFor="note" className="form-label">
                        {t("Note")}
                      </Label>
                      <Input
                        name="note"
                        type="textarea"
                        rows="5"
                        className="form-control"
                        id="note"
                        placeholder={t("Note")}
                        value={formik?.values?.note}
                        onChange={(event: any) =>
                          formik.setFieldValue("note", event?.target?.value)
                        }
                      />
                      {formik.touched.note && formik.errors.note ? (
                        <div className="text-danger mt-2">
                          {formik.errors.note}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <Row className="mb-3 mt-2">
              <Col lg={12}>
                <div className="hstack gap-2 justify-content-end">
                  {isHavePermissionRole(
                    ROLES_FOR_APP.USER_UPDATE,
                    userPermissions
                  ) && (
                    <button type="submit" className="btn btn-primary fs-14">
                      {isLoading && <Spinner size="sm me-2"></Spinner>}
                      {t("Button Save")}
                    </button>
                  )}
                </div>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>

      {isOpenSearchAddress && (
        <Modal
          isOpen={!!isOpenSearchAddress}
          centered={true}
          size="lg"
          scrollable={false}
        >
          <ModalHeader toggle={handleCloseModalAddress}>
            {t("Search Address")}
          </ModalHeader>
          <ModalBody>
            <SearchAddress onSetValueAddress={onSetValueAddress} />
          </ModalBody>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default ApplicationStatus;
